import { toast } from "@/components/Toaster/Toaster";
import { datadogRum } from "@datadog/browser-rum";
import * as Sentry from "@sentry/nextjs";
import { Chatbot } from "@zapier/chatbots-tailwind/dist/types";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";

export const handleChatbotError = (error: unknown, chatbot?: Chatbot) => {
  const errorMessage = error instanceof Error ? error.message : String(error);

  datadogRum.addError(`Chat response error: ${errorMessage}`);
  Sentry.captureException(error);

  toast.error(
    {
      message: chatbot?.customErrorMessage ? (
        <Markdown className="[&_a]:underline" remarkPlugins={[remarkGfm]}>
          {chatbot.customErrorMessage}
        </Markdown>
      ) : (
        `Error: ${errorMessage}`
      ),
    },
    {
      cancel: null,
      dismissible: false,
      duration: Infinity,
    }
  );
};
